// extracted by mini-css-extract-plugin
export var circle = "_2e-2";
export var icon = "_2e-a";
export var iconHighlight = "_2e-0";
export var lg = "_2e-8";
export var md = "_2e-7";
export var outline = "_2e-4";
export var sm = "_2e-6";
export var square = "_2e-1";
export var xl = "_2e-9";
export var xs = "_2e-5";
export var xxs = "_2e-3";